import React, { Component } from "react";
import { View, Image, Animated, Easing } from 'react-native'
import { icons } from "../theme/icons";
import { splashStyles } from '../theme/styles'
import { hp } from "../utils/responsive";
import {getToken} from "../database/UserDal";

export default class SplashScreen extends Component {
    constructor(props) {
        super(props)
        this.animatedValue = new Animated.Value(0)
        this._visibility = new Animated.Value(0);
    }
    render() {
        const introButtonTop = this.animatedValue.interpolate({
            inputRange: [0, 1],
            outputRange: [hp(0), hp(31)]
        })
        const opacity = this._visibility.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 1],
        });
        const introButton = this.animatedValue.interpolate({
            inputRange: [0, 1],
            outputRange: [hp(100), hp(45)]
        })
        return (<View style={splashStyles.container}>
            <Animated.Image source={icons['splash_top']} style={[splashStyles.image, {
                top: introButtonTop, position: 'absolute', opacity: opacity
            }]} />
            <Animated.Image source={icons['splash_bottom']} style={[splashStyles.image, {
                top: introButton, position: 'absolute', opacity: opacity
            }]} />
        </View>)
    }
    componentDidMount() {
        this.animate()
        setTimeout(()=>{
            if(getToken()!=null)
            {
                this.props.navigation.navigate('main')
            }else {
                this.props.navigation.navigate('login')
            }

        },3000)

    }
    animate() {
        this.animatedValue.setValue(0)
        const createAnimation = function (value, duration, easing, delay = 0) {
            return Animated.timing(
                value,
                {
                    toValue: 1,
                    duration,
                    easing,
                    delay
                }
            )
        }

        createAnimation(this.animatedValue, 2000, Easing.linear).start()
        createAnimation(this._visibility, 3000, Easing.linear).start()

    }


}
